/**
 * Global main namespace for the application
 *
 * Entry point of the application
 * @namespace APP
 */

var APP = APP || function () {
	'use strict';
};

/**
 * Main application class
 *
 * @namespace APP
 * @name APP.Main
 */
APP.Main = (/** @lends APP.Main */function () {
	'use strict';

	var exports,
		initialized = false,
		instance;

	/**
	 * Initialize application and needed subclasses<br>
	 * By convention all of the sub modules should have a public `init` method
	 *
	 * @inner
	 * @public
	 * @memberof APP.Main
	 * @returns {void}
	 */
	function init() {

		if (!initialized) {
			initialized = true;
			APP.Performance.init();
			APP.Youtube.init();
			APP.Analytics.init();
			APP.Bind.init();
			APP.HandlebarsHelpers.init();
			APP.Svg.init();
			APP.Service.init();
			APP.Form.init();
			APP.Overlay.init();
			APP.Settings.init();
			APP.PaymentStatus.init();
		}

		APP.Tooltip.init();
		APP.Datepicker.init();
		APP.Template.init();
		APP.Layout.init();
		APP.Login.init();
		APP.DataTable.init();
		APP.BillList.init();
		APP.Accordion.init();
		APP.Chart.init();
		APP.ChartCarousel.init();
		APP.AsyncModule.init();
		APP.Dashboard.init();
		APP.Header.init();
		APP.MobileHeader.init();
		APP.Maintenance.init();
		APP.Documents.init();
		APP.SSO.init();
	}

	function dynamicInit() {
		APP.Tooltip.init();
		APP.Datepicker.init();
		APP.Template.init();
		APP.Layout.init();
		APP.Login.init();
		APP.DataTable.init();
		APP.BillList.init();
		APP.Accordion.init();
		APP.ChartCarousel.init();
		APP.AsyncModule.init();
		APP.Maintenance.init();
	}

	exports = {

		/**
		 * Get singleton APP.Main instance<br>
		 * If the module is already initialized return the instance, if not map the 'init'<br>
		 * function so it can be called
		 *
		 * @public
		 * @memberof APP.Main
		 * @returns {Function|APP.Main} the instance or the 'init' method of the module
		 */
		getInstance: function () {

			if (!instance) {
				instance = init();
			}

			return instance;
		}

	};

	exports.init = dynamicInit;

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
